import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LockClockOutlinedIcon from '@mui/icons-material/LockClockOutlined';
import { UserDeactivate, UserDelete, getUserList, resendToken } from "../../api/casp/user";
import { Action, DefaultPerPageValue, PerPage, Role, UserStatus } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import userImage from "../../assets/images/icons/ticket.png";
import AddUserDrawer from "../../Components/casp/user/addUserDrawer";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { Helmet } from "react-helmet";
import { filter } from "lodash/collection";
import { get } from "lodash/object";
import { getIconPath } from "../../helpers/file_helper";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Search from "../../Components/casp/common/Search";
import CsvUpload from "../../common/CsvUpload";
import SendIcon from "@mui/icons-material/Send";
import Tooltip from '@mui/material/Tooltip';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList"
import { getAllPortfolios } from "../../api/casp/portfolio";
import { useSelector } from "react-redux";

function UserManagement(props) {
  const [userList, setUserList] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUserRow, setSelectedUserRow] = useState();
  const [action, setAction] = useState();
  const [searchItem, setSearchItem] = useState();
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [onMounted, setOnMounted] = useState(false);
  const [isOpenSweetAlertDelete, setIsOpenSweetAlertDelete] = useState(false)
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [portfolio,setPortfolio] = useState()
  const [portfolioFilter,setPortfolioFilter] = useState({})

  const loggedInUser = useSelector((state) => state.Profile.user);

  const columns = [
    {
      field: "index",
      headerName: "#",
      width: 85,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
        </div>
      ),
    },
    {
      field: "uniqueUserId",
      headerName: "Employee ID",
      width: 250,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div className="MuiDataGrid-cellContent">
            {params.row?.uniqueUserId}
          </div>
        </div>
      ),
    },
    {
      field: "firstName",
      headerName: "First Name",
      width: 250,
      filterable: false,
      sortable: false,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      width: 250,
      filterable: false,
      sortable: false,
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 250,
      filterable: false,
      sortable: false,
    },
    {
      field: "contactNo",
      headerName: "Contact No",
      width: 200,
      filterable: false,
      sortable: false,
    },
    {
      field: "gender",
      headerName: "Gender",
      width: 200,
      filterable: false,
      sortable: false,
    },
    {
      field: "projectName",
      headerName: "Startup Name",
      width: 200,
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              // backgroundColor:
              //   highlightRow?.id === params.row?.id ? "#cce6ff" : "",
              padding: "0 10px",
            }}
          ><button
            style={{
              cursor: "pointer",
              color: "blue",
              // textDecoration: "underline",
              border: "none",
              background: "none",
              padding: 0,
              font: "inherit",
            }}
            onClick={() =>
              navigate(
                `/project/${params.row.project.id}/details`
              )
            }
            className="MuiDataGrid-cellContent"
          >
              {params.row.project.name}
            </button>
          </div>
        );
      }
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      filterable: false,
      sortable: false,
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   width: 250,
    //   sortable: false,
    //   filterable: false,
    //   hideable: false,
    //   renderCell: (params) => (
    //     (
    //       <>
    //         <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
    //         <Tooltip title="Edit user">
    //             <Button
    //               disableElevation
    //               variant="contained"
    //               className="viewBtn statusButton"
    //               onClick={() => handleClick(params.row, Action.EDIT)}
    //             >
    //               <EditOutlinedIcon />
    //             </Button>
    //           </Tooltip>
    //           <Tooltip title="Delete user">
    //             <Button
    //               disableElevation
    //               variant="contained"
    //               className="viewBtn statusButton"
    //               onClick={(e) => {
    //                 e.stopPropagation();
    //                 setIsOpenSweetAlert(true);
    //                 setSelectedUserRow(params.row);
    //               }}
    //             >
    //               <DeleteOutlineIcon />
    //             </Button>
    //           </Tooltip>
    //           {!params.row.isActive && (
    //             <Tooltip title="Re-send password link">
    //               <Button
    //                 disableElevation
    //                 variant="contained"
    //                 className="viewBtn statusButton"
    //                 onClick={() => sendResetLink(params.row)}
    //               >
    //                 <SendIcon />
    //               </Button>
    //             </Tooltip>
    //           )}
    //         </div>
    //       </>
    //     )
    //   ),
    // },
  ];

  const [columnData, setColumnData] = useState([...columns]);

  const columHeaderMapping = (name) => {
    switch (name) {
      case "uniqueUserId":
        return props.t("Employee ID")
      case "firstName":
        return props.t("First Name")
      case "lastName":
        return props.t("Last Name")
      case "email":
        return props.t("Email Address")
      case "contactNo":
        return props.t("Contact No")
      case "gender":
        return props.t("Gender")
      case "status":
        return props.t("Status")
      case "projectName":
        return props.t("Startup Name")
      default:
        return
    }
  }

  useEffect(() => {
    if (onMounted) {
      const transLatedHeader = columnData.map((column) => {
        return {
          ...column,
          headerName: props.t(columHeaderMapping(column.field))
        }
      })
      setColumnData(transLatedHeader)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.t])


  const hasCreatePermissionForUserManagement = hasModulePermission(Modules.USER, Action.CREATE)
  const hasEditPermissionForUserManagement = hasModulePermission(Modules.USER, Action.EDIT)
  const hasDeletePermissionForUserManagement = hasModulePermission(Modules.USER, Action.DELETE)

  function makeSVG(parent, tag, attrs) {
    var el = document.createElementNS("http://www.w3.org/2000/svg", tag);
    for (var k in attrs) {
      // eslint-disable-next-line eqeqeq
      if (k == "xlink:href") {
        el.setAttributeNS("http://www.w3.org/1999/xlink", "href", attrs[k]);
      } else {
        el.setAttribute(k, attrs[k]);
      }
    }
  }

  const handleCloseDrawer = async (message) => {
    setIsDrawerOpen(false);
    if (message === "success") {
      setUserList([]);
      if (page > 0) {
        setPage(0);
      } else {
        await fetchUserList(searchItem);
      }
    }

    setSelectedUserRow();
    setAction();
  };

  const handleOpenDrawer = async () => {
    setIsDrawerOpen(true);
  };

  // useEffect(() => {
  //   fetchUserList(searchItem);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [page, rowsPerPage]);

  const location = useLocation();

  useEffect(() => {
    const filterData = location.state?.filterData;
    if (filterData) {
      const parsedFilter = JSON.parse(filterData);  
      fetchUserList(searchItem, parsedFilter)
    } else {
      fetchUserList(searchItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, page, rowsPerPage]);

  useEffect(() => {
    if (hasEditPermissionForUserManagement || hasDeletePermissionForUserManagement) {
      let transLatedHeader = []
      columnData.forEach((column) => {
        if (column.field !== 'actions') {
          transLatedHeader.push({
            ...column,
            headerName: props.t(columHeaderMapping(column.field))
          })
        }
      })
      setColumnData(
        [
          ...transLatedHeader,
          {
            field: "actions",
            headerName: props.t("Actions"),
            width: 250,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => (
              (
                <>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                    {
                      hasEditPermissionForUserManagement &&
                      <Tooltip title={props.t("Edit user")}>
                        <Button
                          disableElevation
                          variant="contained"
                          className="viewBtn statusButton"
                          onClick={() => handleClick(params.row, Action.EDIT)}
                        >
                          <EditOutlinedIcon />
                        </Button>
                      </Tooltip>
                    }
                    {
                      hasDeletePermissionForUserManagement && params.row.status === UserStatus.ACTIVE &&
                      <Tooltip title={props.t("Deactivate User")}>
                        <Button
                          disableElevation
                          variant="contained"
                          className="viewBtn statusButton"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsOpenSweetAlert(true);
                            setSelectedUserRow(params.row);
                          }}
                        >
                          <LockOpenOutlinedIcon />
                        </Button>
                      </Tooltip>
                    }
                    {
                      hasDeletePermissionForUserManagement && params.row.status === UserStatus.INACTIVE &&
                      <Tooltip title={props.t("Activate User")}>
                        <Button
                          disableElevation
                          variant="contained"
                          className="viewBtn statusButton"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsOpenSweetAlert(true);
                            setSelectedUserRow(params.row);
                          }}
                        >
                          <LockOutlinedIcon />
                        </Button>
                      </Tooltip>
                    }
                    {
                      hasDeletePermissionForUserManagement && params.row.status === UserStatus.WAITINGFORACTIVATION &&
                      <Tooltip title={props.t("Activate User")}>
                        <Button
                          disableElevation
                          variant="contained"
                          className="viewBtn statusButton"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsOpenSweetAlert(true);
                            setSelectedUserRow(params.row);
                          }}
                        >
                          <LockClockOutlinedIcon />
                        </Button>
                      </Tooltip>
                    }

                    {
                      hasDeletePermissionForUserManagement &&
                      <Tooltip title={props.t("Delete user")}>
                        <Button
                          disableElevation
                          variant="contained"
                          className="viewBtn statusButton"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsOpenSweetAlertDelete(true);
                            setSelectedUserRow(params.row);
                          }}
                        >
                          <DeleteOutlineIcon />
                        </Button>
                      </Tooltip>
                    }
                    {!params.row.isActive && hasCreatePermissionForUserManagement && params.row.status !== UserStatus.INACTIVE && (
                      <Tooltip title={props.t("Re-send password link")}>
                        <Button
                          disableElevation
                          variant="contained"
                          className="viewBtn statusButton"
                          onClick={() => sendResetLink(params.row)}
                        >
                          <SendIcon />
                        </Button>
                      </Tooltip>
                    )}
                  </div>
                </>
              )
            ),
          },
        ]
      )
    }

    setOnMounted(true);

    if (!hasEditPermissionForUserManagement && !hasDeletePermissionForUserManagement) {
      const transLatedHeader = columns.map((column) => {
        return {
          ...column,
          headerName: props.t(columHeaderMapping(column.field))
        }
      })
      setColumnData(transLatedHeader)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEditPermissionForUserManagement, hasDeletePermissionForUserManagement])

  /** Fetch user list from api */
  const fetchUserList = async (searchItem = "", filters = {}) => {
    try {
      setIsLoading(true);
      let params = {
        page: page + 1,
        perPage: rowsPerPage,
        ...(searchItem && {
          ...searchItem,
        }),
        includeAdmins: false,
        filterFields: filters.filterFields,
        filterInputs: filters.filterInputs
      };

      const res = (await getUserList(params)).data.data;
      let level = (page + 1 - 1) * rowsPerPage;
      const resultData = res.data.map((res) => {
        return {
          id: res.id,
          indexNo: ++level,
          uniqueUserId: res.uniqueUserId,
          firstName: res.firstName,
          lastName: res.lastName,
          email: res.email,
          contactNo: res.contactNo,
          gender: props.t(res.gender),
          status: props.t(res.status),
          address: res.address,
          project: res.project,
          projectName: res?.project?.name,
          department: res.department,
          addressId: res.addressId,
          isActive: res.isActive,
          companyId: res.company.id
        };
      });
      setUserList(resultData);
      setRowCount(res.meta.total);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
  };

  const handleDelete = async (id) => {
    try {
      setIsLoading(true);
      setIsOpenSweetAlertDelete(false);
      const response = (await UserDelete(id)).data;
      toast.success(response.message);
      setIsLoading(false);
      setUserList([]);
      if (page > 0) {
        setPage(0);
      } else {
        await fetchUserList(searchItem);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
    }
  };

  const handleDeactivate = async (id) => {
    try {
      setIsLoading(true);
      setIsOpenSweetAlert(false);
      const response = (await UserDeactivate(id)).data;
      toast.success(response.message);
      setIsLoading(false);
      setUserList([]);
      if (page > 0) {
        setPage(0);
      } else {
        await fetchUserList(searchItem);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
    }
  }

  const handleClick = async (params, action) => {
    setIsDrawerOpen(true);
    setSelectedUserRow(params);
    setAction(action);
  };

  const globalSearch = async (params) => {
    setSearchItem(params.search)
    setUserList([]);

    const filter = {
      filterFields: params.filterFields,
      filterInputs: params.filterInputs
    }
    
    page > 0 ? setPage(0) : fetchUserList(params,filter);
  };

  const getRowId = (row) => row.id;

  const [isPopupOpen, setPopupOpen] = useState(false);
  const openCsvModal = () => {
    setPopupOpen(true);
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
  }

  const sendResetLink = async (params) => {
    try {
      const response = await resendToken({ userId: params.id, companyId: params.companyId })
      if (response.statusCode === 200) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, "linkTags", []), {
                rel: "icon",
              });

              if (!newFaviconElems.length) {
                return;
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href;

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              );

              if (existingFavicons.length) {
                existingFavicons.forEach((e) => e.parentNode.removeChild(e));
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              );
              const iconToShow = <ManageAccountsIcon />;
              //<i className={'ri-git-pull-request-line'}></i>

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true);
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                    iconToShow
                  )}</svg>`
                )}`;
                const parentElem = newFaviconElem.parentNode;
                parentElem.removeChild(newFaviconElem);
                parentElem.appendChild(newFavElement);
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <title>{props.t("User Management")}</title>
        </Helmet>
        <Container fluid>
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={props.t("User List")} />

            {/* <TextField id="outlined-basic" label="Outlined" variant="outlined" placeholder="Search..." /> */}
            <div className="d-flex align-items-center">
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                    label={t("Cohort")}
                    sx={{
                    width: 200,
                    }}
                    searchEnabled={false}
                    listCall={getAllPortfolios}
                    disableClearable={!portfolio}
                    defaultValue={portfolio}
                    apiParams={{
                        order: "updatedAt",
                        direction: "desc",
                        ...(![
                            Role.PROJECT_MANAGER,
                            Role.EPMO_MANAGER,
                            Role.ROOT_ADMIN,
                            Role.VICE_PRESIDENT,
                            Role.PRESIDENT,
                            Role.PROGRAM_MANAGER,
                            Role.EPMO_OFFICER,
                            Role.MENTOR
                        ].includes(loggedInUser?.role?.name) && {
                            filterFields: "portfolioUser",
                            filterInputs: loggedInUser.id,
                        }),
                    }}
                    emitItem={async (newValue) => {
                    setPortfolio(newValue);
                    const filter = {}
  
                      if (newValue?.id) {
                        filter.filterFields = ['portfolioId']
                        filter.filterInputs = [newValue.id]
                      } else {
                        filter.filterFields = []
                        filter.filterInputs = []
                      }
                      setPortfolioFilter(filter)
                      setPage(0)
                      await fetchUserList({search:searchItem},filter)
                    }}
                />
              </div>
              <div className="filterTitle d-flex align-items-center mx-2 taskHeaderSearchField">
                <Search listCall={globalSearch} params={portfolioFilter}/>
              </div>
              {
                hasCreatePermissionForUserManagement && (
                  <>
                    <button
                      className="edit_button d-flex justify-content-center px-3"
                      onClick={handleOpenDrawer}
                    >
                      <p className="mb-0">{props.t("Add User")}</p>
                    </button>
                    <button
                      className="edit_button d-flex justify-content-center px-3 mx-2"
                      onClick={openCsvModal}
                    >
                      <p className="mb-0">{props.t("Upload CSV")}</p>
                    </button>
                  </>
                )
              }
            </div>
          </div>
          {isPopupOpen &&
            <CsvUpload
              createAssetsPermission="true"
              viewAssetsPermission="true"
              updateAssetsPermission="true"
              open={isPopupOpen}
              refresh={async () => await fetchUserList()}
              onClose={handlePopupClose}
              module={Modules.USER}
            />
          }
          <div className="projectTypeTable my-4">
            {userList.length > 0 && (
              <DataGrid
                rows={userList}
                columns={columnData}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
                getRowHeight={() => 'auto'}
                // style={{ width: '100%', height: '300px'}}
                localeText={{
                  noRowsLabel: props.t("No rows"),
                  MuiTablePagination: {
                    labelRowsPerPage: props.t("Rows per page:"),
                  },
                }}
              />
            )}
            {userList.length === 0 && isLoading && <Loader />}
            {userList.length === 0 && !isLoading && (
              <NodataFound text={props.t("No users to show")} icon={userImage} />
            )}
          </div>
        </Container>
        <AddUserDrawer
          isOpen={isDrawerOpen}
          handleClose={handleCloseDrawer}
          action={action}
          selectedUserRow={selectedUserRow}
        />

        {isOpenSweetAlert && (
          <SweetAlert
            title={props.t("Are you sure you want to deactivate this user?")}
            warning
            showCancel
            confirmBtnText={props.t("OK")}
            cancelBtnText={props.t("Cancel")}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={async () => {
              await handleDeactivate(selectedUserRow.id);
            }}
            onCancel={() => {
              setIsOpenSweetAlert(false);
            }}
          ></SweetAlert>
        )}

        {isOpenSweetAlertDelete && (
          <SweetAlert
            title={props.t("Are you sure you want to delete this user?")}
            warning
            showCancel
            confirmBtnText={props.t("OK")}
            cancelBtnText={props.t("Cancel")}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={async () => {
              await handleDelete(selectedUserRow.id);
            }}
            onCancel={() => {
              setIsOpenSweetAlertDelete(false);
            }}
          ></SweetAlert>
        )}
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(UserManagement)
